
import React, { useEffect, useRef, useState } from 'react';
import { CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EyeOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import { Tree, Divider, Table, Popconfirm, Card, Tooltip, Switch, Input, Button, Tag, Row, Col, Drawer, Form, Select, DatePicker, Tabs,Typography } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import Highlighter from 'react-highlight-words';
import Link from 'antd/lib/typography/Link';
import form from 'antd/lib/form';
import { GlobalVariableValues, OperationTypeEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { BeheadingService, LotCodeOpsService, ProdlogService, ProductionInventoryService } from '@gtpl/shared-services/production';
import { LotCodeDropDown, ProductionInventoryDetails } from '@gtpl/shared-models/production-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { ProductionLogRequest } from 'libs/shared-models/production-management/src/lib/production-inv/production-log.req';
import moment from 'moment';
import { Excel } from 'antd-table-saveas-excel';
import {  DownloadOutlined } from '@ant-design/icons';
import FormItem from 'antd/lib/form/FormItem';


const { Option } = Select;

export interface ProductionInventoryOperationsProps{}

export function ProductionInvenOPerationsGrid(props:ProductionInventoryOperationsProps){
  const [form] = Form.useForm();
  const searchInput = useRef(null);
  const { TabPane } = Tabs;
  const [searchedColumn, setSearchedColumn] = useState('');
  const[searchText, setSearchText] = useState('');
  const { RangePicker } = DatePicker;
  const [page, setPage] = React.useState(1);
  const production = new ProductionInventoryService();
  const beheadService = new BeheadingService();
  const [behead, setBeheadData] = useState<ProductionInventoryDetails[]>([]);
  const [selectedEstimatedFromDate, setSelectedEstimatedFromDate] = useState(undefined);
  const [selectedEstimatedToDate, setSelectedEstimatedToDate] = useState(undefined);
  const [saleId, setSaleId] = useState(0);
const [selectedunit, setUnit] = useState<number>(0)
  const [disable,setDisable]=useState<boolean>(false);
  const [reportData, setReportData] = useState<any[]>([]);
  const lotCodeService = new LotCodeOpsService();
  const [lotNumbers, setLotNumbers] = useState<LotCodeDropDown[]>([]);
  const [lotNumber, setLotNumber] = useState("");
  const [activeTab, setActiveTab] = useState('1'); // Default active tab
  const [columns,setColumns] = useState<any[]>([])
  const [tabName,setTabName] = useState<string>(OperationTypeEnum.BE_HEADING)
  const [operationwiseCount,setOperationwiseCount] = useState<any[]>([])
  const [deheadingCount,setDeheadingCount] = useState<number>(0)
  const [gradingCount,setgradingCount] = useState<number>(0)
  const [vaCount,setvaCount] = useState<number>(0)
  const [soakingCount,setsoakingCount] = useState<number>(0)
  const service = new ProdlogService();
  const { Text } = Typography;
  useEffect(() => {
    GlobalVariableValues.productionVersion == 'V1' ? (
      setColumns(columnsSkelton)
    ) : (
      setColumns(
        columnsSkelton.filter(e => {
          return(
            e.dataIndex != 'poNumber' && 
            e.dataIndex != 'wastageQuantity' && 
            e.dataIndex != 'rejectedQuantity'
          )
        })
      )
    )
   
  },[])

  const handleChange = (value) => {
    // setDisplay("none");
    setLotNumber(value);
  };

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  useEffect(() => {
    // getBeheadingInventory();
    getOperationWiseCount()
    getProductionLogReport();
    getAllLotNumbers();
    if (Number(localStorage.getItem('unit_id')) != 5) {
      form.setFieldsValue({ unitId: Number(localStorage.getItem('unit_id')) })
    }
    
  }, []);

  const getAllLotNumbers = async () => {
    try {
      const res = await service.getLotNumberDetails();
      if (res.status) {
        setLotNumbers(res.data);
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    } catch (err) {
      AlertMessages.getErrorMessage(err.message);
    }
  };

  const getOperationWiseCount = () => {
    production.getOperationWiseCount().then(res => {
      if(res.status){
        console.log(res,'====')
        setOperationwiseCount(res.data)
        setDeheadingCount(res.data.find(e => {return(e.operation == OperationTypeEnum.BE_HEADING)}).count)
        setgradingCount(res.data.find(e => {return(e.operation == OperationTypeEnum.GRADING)}).count)
        setvaCount(res.data.find(e => {return(e.operation == OperationTypeEnum.VALUE_ADDITION)}).count)
        setsoakingCount(res.data.find(e => {return(e.operation == OperationTypeEnum.SOAKING)}).count)
      }else{
        setOperationwiseCount([])
      }
    })
  }

  const getProductionLogReport = (onReset?:boolean)=>{
    // const plant = Number(localStorage.getItem('unit_id'))
    const lotNumber = form.getFieldValue('lotNumber')
    let fromDate = onReset ? undefined : selectedEstimatedFromDate;
    let toDate = onReset ? undefined : selectedEstimatedToDate;
    const req = new ProductionLogRequest();
    req.lotNumber=lotNumber
    req.fromDate=fromDate
    req.toDate=toDate
    if (Number(localStorage.getItem('unit_id')) != 5) {
      req.unitId = Number(localStorage.getItem('unit_id'));
    } else {
      req.unitId = selectedunit
    }
    req.operation = tabName
    production.getProductionInventoryReport(req).then((res)=>{
      if(res.status){
        setReportData(res.data);
        setActiveTab
      }else{
        setReportData([]);
        setActiveTab
      }
    }).catch((err)=>{
      AlertMessages.getErrorMessage(err.message);
      setReportData([]);
      setActiveTab
    })
  }

  const EstimatedETDDate = (value) => {
    if (value) {
      console.log(value)
      const fromDate = new Date(value[0].format('yyyy-MM-DD'));
      const toDate = new Date(value[1].format('yyyy-MM-DD'));
      setSelectedEstimatedFromDate(fromDate)
      setSelectedEstimatedToDate(toDate)
      console.log(fromDate)
    }
  }
//   const getBeheadingInventory = () => {
//     const beheadInvReq = new UnitRequest(Number(localStorage.getItem('unit_id'))
//    );
//    beheadService.getBeheadingInventoryInfo(beheadInvReq).then((res) => {
//        if (res.status) {
//         setBeheadData(res.data);          

//        } 
//        else {
//          if (res.intlCode) {
//            AlertMessages.getErrorMessage(res.internalMessage);
//          } else {
//            AlertMessages.getErrorMessage(res.internalMessage);
//          }
//        }
//      })
//      .catch((err) => {
//        AlertMessages.getErrorMessage(err.message);
//      });
//  };

    const goToSaleDetailView = (saleOrderId: number) => {
        setSaleId(saleOrderId);
        console.log("soid",saleOrderId);
        // setIsModalVisible(true)
      }
    const columnsSkelton: ColumnProps<any>[] = [
        {
            title: 'Lot Code',
            dataIndex: 'lotNumber',
            sorter: (a, b) => a.lotNumber.localeCompare(b.lotNumber),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotNumber'),
          },
          {
            title: 'Po Number',
          dataIndex: 'poNumber',
          },
        //   {
        //     title: 'Operation',
        //   dataIndex: 'operation',
        //   },
          
         
          {
            title: 'HL Count',
          dataIndex: 'inputGrade',
          ...getColumnSearchProps('inputGrade'),
          render:(text,record) => {
            return(
              <>{Number(text)}</>
            )
          }
          },
          {
            title: 'HL Rate',
          dataIndex: 'outputGrade',
          ...getColumnSearchProps('outputGrade'),
          render:(text,record) => {
            return( 
              <>{Number(text)}</>
            )
          }
          },


          {
            title: 'product',
          dataIndex: 'product',
         
          },

          
          {
            title: 'Transfer Quantity',
          dataIndex: 'intransitQuantity',
          },
              {
                title: 'Physical Quantity',
                dataIndex: 'physicalQuantity',
                // sorter: (a, b) => a.poNumber?.localeCompare(b.poNumber),
                // sortDirections: ['descend', 'ascend'],
                //   ...getColumnSearchProps('poNumber'),
                // render: (value, record) => 
                // <Link  onClick={e => goToSaleDetailView(record.saleOrderId)} >{record.poNumber}</Link>
                },
                
                // {
                //   title: 'Planned Output Quantity',
                // dataIndex: 'plannedOutputQuantity',
                // },
             
                
                {
                  title: 'Wastage Quantity',
                dataIndex: 'wastageQuantity',
                },
                {
                  title: 'Rejected Quantity',
                dataIndex: 'rejectedQuantity',
                },
                {
                  title: 'Wip Quantity',
                dataIndex: 'wipQuantity',
                },
                {
                  title: 'I/P Boxes',
                dataIndex: 'ipBoxes',
                },

                  {
                    title: 'O/P Boxes',
                    dataIndex: 'opBoxes',
                    // render: (value) => {
                    //   return <div style={{ textAlign: 'right', color: "black", fontWeight: 'bold' }}>{value}</div>
                    // }
                  },
                 
    ];

    const onReset = () => {
      form.resetFields();
      getProductionLogReport(true); 
    };
      const onChange = (pagination, filters, sorter, extra) => {
        console.log('params', pagination, filters, sorter, extra);
      }
    

      const exportExcel = () => {
        const excel = new Excel();
        let dataSource;
        let data = []; 
        switch (activeTab) {
          case '1': 
            dataSource = reportData.filter(res => res.operation === OperationTypeEnum.BE_HEADING);
      
            data = [
              { title: 'Lot Code', dataIndex: 'lotNumber' },
              { title: 'HL Count', dataIndex: 'inputGrade' },
              { title: 'Transfer Quantity', dataIndex: 'intransitQuantity' },
              { title: 'Physical Quantity', dataIndex: 'physicalQuantity' }
            ].filter(e => e.dataIndex !== 'productionInventoryId' && e.dataIndex !== 'outputGrade' && e.dataIndex !== 'wipQuantity');
      
            if (GlobalVariableValues.productionVersion === 'V1') {
              data.push(
                { title: 'Po Number', dataIndex: 'poNumber' },
                { title: 'Wastage Quantity', dataIndex: 'wastageQuantity' },
                { title: 'Rejected Quantity', dataIndex: 'rejectedQuantity' }
              );
            }
            break;
      
          case '2':
            dataSource = reportData.filter(res => res.operation === OperationTypeEnum.GRADING);
            data = [
              { title: 'Lot Code', dataIndex: 'lotNumber' },
              { title: 'HL Count', dataIndex: 'inputGrade' },
              { title: 'Transfer Quantity', dataIndex: 'intransitQuantity' },
              { title: 'Physical Quantity', dataIndex: 'physicalQuantity' },
              { title: 'WIP Quantity', dataIndex: 'wipQuantity' }
            ];
      
            if (GlobalVariableValues.productionVersion === 'V1') {
              data.push(
                { title: 'Po Number', dataIndex: 'poNumber' },
                { title: 'Wastage Quantity', dataIndex: 'wastageQuantity' },
                { title: 'Rejected Quantity', dataIndex: 'rejectedQuantity' }
              );
            }
            break;
      
          case '3': 
            dataSource = reportData.filter(res => res.operation === OperationTypeEnum.VALUE_ADDITION);
            data = [
              { title: 'Lot Code', dataIndex: 'lotNumber' },
              { title: 'HL Count', dataIndex: 'inputGrade' },
              { title: 'production', dataIndex: 'productionInventoryId' },
              { title: 'Transfer Quantity', dataIndex: 'intransitQuantity' },
              { title: 'Physical Quantity', dataIndex: 'physicalQuantity' },
              { title: 'WIP Quantity', dataIndex: 'wipQuantity' }
            ];
      
            if (GlobalVariableValues.productionVersion === 'V1') {
              data.push(
                { title: 'Po Number', dataIndex: 'poNumber' },
                { title: 'Wastage Quantity', dataIndex: 'wastageQuantity' },
                { title: 'Rejected Quantity', dataIndex: 'rejectedQuantity' }
              );
            }
            break;
      
          case '4': 
            dataSource = reportData.filter(res => res.operation === OperationTypeEnum.SOAKING);
            data = [
              { title: 'Lot Code', dataIndex: 'lotNumber' },
              { title: 'HL Count', dataIndex: 'inputGrade' },
              { title: 'production', dataIndex: 'productionInventoryId' },
              { title: 'Transfer Quantity', dataIndex: 'intransitQuantity' },
              { title: 'Physical Quantity', dataIndex: 'physicalQuantity' },
              { title: 'WIP Quantity', dataIndex: 'wipQuantity' }
            ];
      
            if (GlobalVariableValues.productionVersion === 'V1') {
              data.push(
                { title: 'Po Number', dataIndex: 'poNumber' },
                { title: 'Wastage Quantity', dataIndex: 'wastageQuantity' },
                { title: 'Rejected Quantity', dataIndex: 'rejectedQuantity' }
              );
            }
            break;
      
          case '5': 
            dataSource = reportData.filter(res => res.operation === OperationTypeEnum.FREEZING);
            data = [
              { title: 'Lot Code', dataIndex: 'lotNumber' },
              { title: 'HL Count', dataIndex: 'inputGrade' },
              { title: 'Transfer Quantity', dataIndex: 'intransitQuantity' },
              { title: 'Physical Quantity', dataIndex: 'physicalQuantity' },
              { title: 'WIP Quantity', dataIndex: 'wipQuantity' }
            ];
      
            if (GlobalVariableValues.productionVersion === 'V1') {
              data.push(
                { title: 'Po Number', dataIndex: 'poNumber' },
                { title: 'Wastage Quantity', dataIndex: 'wastageQuantity' },
                { title: 'Rejected Quantity', dataIndex: 'rejectedQuantity' }
              );
            }
            break;
      
          default:
            dataSource = [];
            data = [];
        }
        if (!dataSource || dataSource.length === 0) {
          console.error("No data to export.");
          return;
        }
      
        if (!data || data.length === 0) {
          console.error("No columns defined for export.");
          return;
        }
        excel
          .addSheet('Operation-Wise-Inventory')
          .addColumns(data)
          .addDataSource(dataSource, { str2num: true })
          .saveAs('Operation-Wise-Inventory.xlsx');
      };
      
    
      const handleTabChange = (key) => {
        console.log(key,'--')
        setActiveTab(key);
        if(key == 1){
          setTabName(OperationTypeEnum.BE_HEADING)
        }else if(key == 2){
          setTabName(OperationTypeEnum.GRADING)
        }else if(key == 3){
          setTabName(OperationTypeEnum.VALUE_ADDITION)
        }else if(key == 4){
          setTabName(OperationTypeEnum.SOAKING)
        }
      }
      useEffect(() => {
        getProductionLogReport()
      },[tabName])
    return(
        <Card
        title={<span style={{ color: 'white' }}>Operation Wise Inventory</span>}
        style={{ textAlign: 'center' }}
        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        extra={
          <div>
            <Button icon={<DownloadOutlined />} onClick={exportExcel} style={{marginRight:30}}>
              GET EXCEL
            </Button></div>}
        >
          <Form layout={'vertical'} form={form}>
          <Row gutter={[24,24]}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 4 }}>
            <FormItem name='lotNumber' label='Lot Number'
            //  rules={[{ required: true }]}
             >
              <Select placeholder='Select Job Number' allowClear showSearch optionFilterProp='children'>
                {lotNumbers.map((lot) => (
                  <Option key={lot.lotNumber} value={lot.lotNumber}>
                    {lot.lotNumber}
                  </Option>
                ))}
              </Select>
            </FormItem>
          </Col>
          <Col style={{ padding: '20px', marginTop: '30px' }}>
            <Button type="primary" style={{ marginRight: '4px' }} disabled={disable} 
            onClick={() => getProductionLogReport()}
            >
              Get Report
            </Button>
            <Button style={{ marginLeft: '5px' }} type="primary" htmlType="submit" onClick={onReset}> Reset </Button>
          </Col>
          </Row>
          </Form>
        <Tabs type={'card'} tabPosition={'top'} onChange={handleTabChange}
        activeKey={activeTab}
        >
        <TabPane key='1'
          tab={<span style={{ color: '#52c41a' }}>Deheading: { GlobalVariableValues.productionVersion == 'V1' ?  reportData.filter(res => res.operation === OperationTypeEnum.BE_HEADING).length : deheadingCount} </span>}
        >
          <Table
            columns={columns.filter(e => e.dataIndex !== 'product' && e.dataIndex !== 'outputGrade' && e.dataIndex !== 'wipQuantity' && e.dataIndex !== 'ipBoxes' && e.dataIndex !== 'opBoxes')} dataSource={reportData.filter(res => res.operation === OperationTypeEnum.BE_HEADING)}
            scroll={{x: 'max-content'}}
            pagination={{
              onChange(current) {
                setPage(current);
              },
              defaultPageSize: 100,
            }}
            onChange={onChange}
            bordered
           
  summary={(data) => {
    const totalTransferQuantity = data.reduce((sum, record) => sum + (Number(record.intransitQuantity) || 0), 0);
    const totalPhysicalQuantity = data.reduce((sum, record) => sum + (Number(record.physicalQuantity) || 0), 0);

    return (
      <Table.Summary.Row>
        
       <Table.Summary.Cell index={0} >Total 
        </Table.Summary.Cell>

        {/* <Table.Summary.Cell index={3}>
          {totalProduction}
        </Table.Summary.Cell> */}
        <Table.Summary.Cell index={4} colSpan={2}>
          {totalTransferQuantity}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5}>
          {totalPhysicalQuantity}
        </Table.Summary.Cell>
       
      </Table.Summary.Row>
    );
  }}
          />

        </TabPane>
        <TabPane key='2'
          tab={<span style={{ color: '#d4b106' }}>Grading: {GlobalVariableValues.productionVersion == 'V1' ? reportData.filter(res => res.operation === OperationTypeEnum.GRADING).length : gradingCount} </span>}
        >
          <Table
            columns={columns.filter(e => e.dataIndex !== 'product' && e.dataIndex !== 'wipQuantity' && e.dataIndex!== 'ipBoxes' && e.dataIndex !== 'opBoxes')}dataSource={reportData.filter(res => res.operation === OperationTypeEnum.GRADING)}
            scroll={{ x: true }}
            pagination={{
              onChange(current) {
                setPage(current);
              },
              defaultPageSize: 100,
            }}
            onChange={onChange}
            bordered
            summary={(data) => {
              const totalTransferQuantity = data.reduce((sum, record) => sum + (Number(record.intransitQuantity) || 0), 0);
              const totalPhysicalQuantity = data.reduce((sum, record) => sum + (Number(record.physicalQuantity) || 0), 0);
          
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}  >
                    Total
                  </Table.Summary.Cell>
                  {/* <Table.Summary.Cell index={3}>
                    {totalProduction}
                  </Table.Summary.Cell> */}
                  <Table.Summary.Cell index={4} colSpan={3}>
                    {totalTransferQuantity}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5}>
                    {totalPhysicalQuantity}
                  </Table.Summary.Cell>
                 
                </Table.Summary.Row>
              );
            }}
          />

        </TabPane>

        <TabPane key='3'
          tab={<span style={{ color: '#f5222d' }}>Value Addition: {GlobalVariableValues.productionVersion == 'V1' ? reportData.filter(res => res.operation === OperationTypeEnum.VALUE_ADDITION).length : vaCount} </span>}
        >
          <Table
            columns={columns.filter(e => e.dataIndex !== 'outputGrade' && e.dataIndex!== 'ipBoxes' && e.dataIndex !== 'opBoxes')}
            dataSource={reportData.filter(res => res.operation === OperationTypeEnum.VALUE_ADDITION)}
            scroll={{ x: true }}
            pagination={{
              onChange(current) {
                setPage(current);
              },
              defaultPageSize: 100,
            }}
            onChange={onChange}
            bordered
            summary={(data) => {
              const totalTransferQuantity = data.reduce((sum, record) => sum + (Number(record.intransitQuantity) || 0), 0);
              const totalPhysicalQuantity = data.reduce((sum, record) => sum + (Number(record.physicalQuantity) || 0), 0);
          const totalWpQuantity = data.reduce((sum,record)=> sum + (Number(record.wipQuantity) || 0), 0)
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}   >
                    Total
                  </Table.Summary.Cell>
                  
                  <Table.Summary.Cell index={3} colSpan={3}>
                    {totalTransferQuantity}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4} colSpan={1}>
                    {totalPhysicalQuantity}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5} colSpan={1}>
                  {totalWpQuantity}
                  </Table.Summary.Cell>
                 
                </Table.Summary.Row>
              );
            }}
          />

        </TabPane>
        <TabPane key='4'
          tab={<span style={{ color: '#08979c' }}>Soaking: {GlobalVariableValues.productionVersion == 'V1' ? reportData.filter(res => res.operation === OperationTypeEnum.SOAKING).length : soakingCount} </span>}
        >
          <Table
            columns={columns.filter(e =>  e.dataIndex !== 'outputGrade' && e.dataIndex!== 'ipBoxes' && e.dataIndex !== 'opBoxes')}
            dataSource={reportData.filter(res => res.operation === OperationTypeEnum.SOAKING)}
            scroll={{ x: true }}
            pagination={{
              onChange(current) {
                setPage(current);
              },
              defaultPageSize: 100,
            }}
            onChange={onChange}
            bordered
            summary={(data) => {
              const totalTransferQuantity = data.reduce((sum, record) => sum + (Number(record.intransitQuantity) || 0), 0);
              const totalPhysicalQuantity = data.reduce((sum, record) => sum + (Number(record.physicalQuantity) || 0), 0);
              const totalWpQuantity = data.reduce((sum,record)=> sum + (Number(record.wipQuantity) || 0), 0)
              return (
                <>
                    <Table.Summary.Row >
                    <Table.Summary.Cell index={0}  ><Text style={{ textAlign: "left",fontWeight:"bold"}} >Total </Text></Table.Summary.Cell>

                  
                  <Table.Summary.Cell index={4} colSpan={3}>
                    {totalTransferQuantity}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5}>
                    {totalPhysicalQuantity}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5} colSpan={1}>
                  {totalWpQuantity}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
             </> );
            }}
          />

        </TabPane>
        {
          GlobalVariableValues.productionVersion == 'V1' ? (<>
            <TabPane key='5'
              tab={<span style={{ color: 'blue' }}>Freezing: {reportData.filter(res => res.operation === OperationTypeEnum.FREEZING).length} </span>}
            >
              <Table
                columns={columns}
                dataSource={reportData.filter(res => res.operation === OperationTypeEnum.FREEZING)}
                scroll={{ x: true }}
                pagination={{
                  onChange(current) {
                    setPage(current);
                  },
                  defaultPageSize: 100,
                }}
                onChange={onChange}
                bordered
                summary={(data) => {
                  const totalTransferQuantity = data.reduce((sum, record) => sum + (Number(record.intransitQuantity) || 0), 0);
                  const totalPhysicalQuantity = data.reduce((sum, record) => sum + (Number(record.physicalQuantity) || 0), 0);
              
                  return (
                    <>
                    <Table.Summary.Row >
                    <Table.Summary.Cell index={0} colSpan={1} ><Text style={{ textAlign: "center",fontWeight:"bold", marginLeft:200}} >Total :</Text></Table.Summary.Cell>
                      
                      <Table.Summary.Cell index={4}>
                        {totalTransferQuantity}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={5}>
                        {totalPhysicalQuantity}
                      </Table.Summary.Cell>
                     
                    </Table.Summary.Row></>
                  );
                }}
              />

            </TabPane>
          
          </>) : (<></>)
        }

        </Tabs>
        {/* <Row>
        <Table
            // rowKey={record => record.downtimeTrackingId}
            columns={columnsSkelton}
            dataSource={reportData}
            pagination={{
              onChange(current) {
                setPage(current);
              }
            }}
            size='small'
            
            scroll={{ y:400 }}
            bordered />
            </Row> */}
    
        </Card>
    )
}
export default ProductionInvenOPerationsGrid;

